import { render, staticRenderFns } from "./AsientoComponent.vue?vue&type=template&id=638a8fd1"
import script from "./AsientoComponent.vue?vue&type=script&lang=js"
export * from "./AsientoComponent.vue?vue&type=script&lang=js"
import style0 from "./AsientoComponent.vue?vue&type=style&index=0&id=638a8fd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports